import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty } from '../firestore/UserProfileNotification/schema'
import type { FirestoreUserProfileNotification } from '../firestore/UserProfileNotification'

export class UserProfileNotification extends ObservableModelWithDecorators<FirestoreUserProfileNotification> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileNotification>
  ) {
    super(repository, doc)
  }
}
